<template>
	<div class="upload-img-box">
		<el-upload
			ref="xlUpload"
			:action="ossObj.host || ''"
			:data="ossData"
			list-type="picture-card"
			:multiple="multiple"
			:on-preview="handlePictureCardPreview"
			:on-remove="handleRemove"
			:file-list="fileList"
			:before-upload="beforeUpload"
			:on-change="fileChange"
			:on-success="successFile"
			:auto-upload="true"
			:disabled="disabled"
		>
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
import { S4 } from "@/utils/utils";
export default {
	props: {
		type: {
			type: String,
			default: "picture", //picture 图片 list 文件列表
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		accept: {
			type: Array,
			default: () => ["png", "jpg", "jpeg"],
		},
		uploadProps: {
			type: Object,
			default: () => {
				return {
					maxSize: 2,
				};
			},
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			imagesList: [],
			fileList: [],
			dialogImageUrl: "",
			dialogVisible: false,
			ossData: {},
			ossObj: {},
			dir: "bill",
			sysFile: {},
		};
	},
	created() {
		this.getOssSign();
	},
	methods: {
		//文件校验
		checkFile(file) {
			let typeName =
				file.name.split(".")[file.name.split(".").length - 1] || "";
			//文件格式
			console.log(file, "file");
			if (this.accept) {
				let accept = this.accept;
				const isImg = accept.includes(typeName);
				if (!isImg) {
					this.$message.error(`只能上传${accept}格式`);
					return false;
				}
			}

			//大小判断 M
			if (this.uploadProps?.maxSize) {
				let maxSize = file?.size / 1024 / 1024 < this.uploadProps.maxSize;
				console.log(maxSize);
				if (!maxSize) {
					this.$message.warning(
						`上传文件大小不能超过${this.uploadProps.maxSize}MB!`
					);
					return false;
				}
			}
			this.sysFile.name = file.name;
			return true;
		},
		beforeUpload(file) {
			console.log(file, "beforeUpload");
			//文件后缀

			let typeName =
				file.name.split(".")[file.name.split(".").length - 1] || "";
			console.log(typeName);
			this.sysFile.uid = file.uid;
			this.sysFile.typeName = typeName;
			if (!this.checkFile(file)) {
				return false;
			}
			//文件命名
			const time = new Date().getTime();
			this.ossData.key = `${
				this.ossObj?.dir
			}${time}_${S4()}${Math.random()}.${typeName}`;

			return true;
		},
		fileChange(file) {
			console.log(file, "fileChange");
		},
		//预览
		previewFile(file) {
			console.log(file);
		},
		//失败
		errorFile(err) {
			this.$message.warning(err);
		},
		//超出
		exceedFile(limt) {
			this.$message.warning(`只能上传${this.uploadProps.limit}个文件`);
			this.$emit("exceedFile", limt);
		},
		//上传
		async submit() {
			console.log( "submit");
			this.successList = [];
			console.log(this.fileList);
			for (const file of this.fileList) {
				console.log(file);
				let typeName =
					file.name.split(".")[file.name.split(".").length - 1] || "";
				let formData = new FormData();
				let path = "";
				let url = "";
				//文件命名
				const time = new Date().getTime();
				path = `${this.ossObj?.dir}${time}_${S4()}.${typeName}`;
				formData.append("ossAccessKeyId", this.ossData.ossAccessKeyId);
				formData.append("policy", this.ossData.policy);
				formData.append("signature", this.ossData.signature);
				formData.append("key", path);
				formData.append("file", file.raw);
				url = this.ossObj.host + "/" + path;
				console.log(formData);
				const res = await this.$axios.post(this.ossObj.host, formData);
				if (res.status == 204) {
					this.$emit("successFile", url);
					this.successList.push(url);
				} else {
					this.$message.warning("上传失败");
				}
			}
			this.$emit("successList", this.successList);
		},

		//上传成功
		successFile() {
			this.imagesList.push({
				url: this.ossObj.host + "/" + this.ossData.key,
				name: this.sysFile.name,
				typeName: this.sysFile.typeName,
				uid: this.sysFile.uid,
			});
			console.log("successFile", this.imagesList, this.ossData);
		},

		handleRemove(file) {
			console.log(file, "handleRemove", this.imagesList);
			this.imagesList = this.imagesList.filter((item) => item.uid !== file.uid);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		// api请求签名
		async getOssSign() {
			console.log(this.$config.ossAppDir, "getOssSign");
			const ossDir = `${this.$config.ossAppDir}/${this.dir}`;
			const res_oss = await this.$api.getOssSign({ dir: ossDir });
			if (res_oss) {
				this.ossObj = res_oss;
				this.ossData = {
					ossAccessKeyId: res_oss.accessid,
					policy: res_oss.policy,
					signature: res_oss.signature,
				};
			} else {
				this.$message.error("获取oss签名失败");
			}
		},
		getImagesList(type = "url") {
			let list = JSON.parse(JSON.stringify(this.imagesList));
			let value = [];
			if (type === "url") {
				value = list.map((item) => item.url);
			}
			return value;
		},
		setImagesList(list) {
			let imgs=[]
			this.fileList = list.map((url) => {
				let value={
					url: url,
					name: url,
					uid: url,
					status: "success",
				}
				imgs.push(value)
				return value
			});
			this.imagesList = imgs;
			console.log("setImagesList", this.fileList);
		},
	},
};
</script>

<style lang="scss" scoped>
.upload-img-box {
}
</style>
